<template>
	<div>
		<div @mousemove="move" class="w3l-banner">
			<div :style="
				'transform: translate(' +
				(position == 'left' ? '20' : '-20') +
				'px,' +
				(position2 == 'top' ? '10' : '-10') +
				'px) scale(1.1)'
			" class="banner-image"></div>
			<div class="titleBox" :class="contType == 'e' ? 'titleBoxe' : ''">
				<div class="wow flipInX titleT1" :class="contType == 'e' ? 'titleT1e' : ''">{{
					contList.title1[contType]
				}}</div>
				<div class="wow flipInX titleT2" :class="contType == 'e' ? 'titleT2e' : ''">{{ contList.title2[contType] }}</div>
				<img class="wow bounceInDown titlebgIcon1" src="../assets/img/AboutUs/guang.svg" alt="" />
				<img class="wow bounceInDown titlebgIcon11" src="../assets/img/AboutUs/guang.png" alt="" />
				<img class="wow bounceInDown titlebgIcon2" src="../assets/img/AboutUs/map.png" alt="" />
				<img class="wow bounceInUp titlebgIcon3" src="../assets/img/AboutUs/jz.svg" alt="" />
				<img class="wow bounceInLeft titlebg" src="../assets/img/ecommerce-development-calicut.png" alt="" />
			</div>
		</div>
		<div class="twoSectionBoxStyle">
			<div class="twoSectionTitleBoxStyle" v-if="contType == 'z'">
				<div class="wow bounceInUp twoTitleT2Style">
			<p class="cates">
				<img class="thumb" src="../assets/img/custom-website-site-builder.jpg"/>
				<div class="t">网站建设</div>
				在当今数字时代，拥有一个专业且功能齐全的网站对于任何企业来说都是至关重要的。我们Suntone Technology Co., Limited明白，并不是每个子商户都有技术专长或资源来建立自己的网站。因此，我们提供全面的网站建设服务。我们经验丰富的开发人员和设计师团队将与您紧密合作，创建一个不仅外观出色而且用户体验优秀的定制网站。从初始设计概念到最终部署，我们处理网站创建过程的每一个方面，确保您的在线形象既有效又吸引人。</p>
			<br style="clear: both;"/>
			<p class="cates">
				<img class="thumb" src="../assets/img/h3-image-2.png"/>
				<div class="t">搜索引擎优化（SEO）
				</div>
				在搜索引擎上的可见性对于增加流量和提升销售至关重要。我们Suntone Technology Co., Limited的SEO服务旨在帮助子商户在搜索引擎结果页面上获得更高排名。我们采用多种策略，包括关键词研究、页面优化、内容创建和链接建设，以增强您网站的可见性。通过提高您的搜索引擎排名，我们帮助您吸引更多的有机流量，从而增加销售并增强在线形象。我们的团队始终跟踪最新的SEO最佳实践和算法变化，确保您的网站在不断变化的数字环境中保持竞争力。</p>
			<br style="clear: both;"/>
			<p class="cates">
				<img class="thumb" src="../assets/img/selection-product.webp"/>
				<div class="t">产品选择
				</div>
				选择合适的产品进行销售可以决定您的业务成败。我们Suntone Technology Co., Limited提供产品选择服务，帮助子商户做出关于库存的明智决策。我们的专家分析市场趋势、客户偏好和竞争格局，识别出需求高且盈利能力强的产品。通过利用我们的见解和专业知识，您可以为您的商店储备更有可能销售的商品，从而减少未售出库存的风险并最大化您的收入潜力。无论您是刚起步还是希望扩展产品线，我们的产品选择服务都能为您提供成功所需的指导。</p><br style="clear: both;"/>
				<p class="cates">
				<img class="thumb" src="../assets/img/From-Concept-to-Launch_-Building-a-Product-with-AI-Assistance-scaled.jpg"/>
				<div class="t">AI功能集成
				</div>
				人工智能（AI）正在改变企业与客户互动的方式。我们Suntone Technology Co., Limited提供AI功能集成服务，帮助子商户提升客户服务和运营效率。我们的AI解决方案包括先进的功能，如AI聊天机器人，能够为您的客户提供即时、个性化的支持，回答常见问题并协助完成常见任务。通过将AI集成到您的网站中，您可以改善用户体验，缩短响应时间，并让您的团队专注于更复杂的问题。我们的AI服务设计为可扩展且适应性强，确保它们满足您的特定业务需求，并帮助您在竞争中保持领先。</p>
				<br style="clear: both;"/>
				
				<div style="text-align: center;">了解更多，请联系 <a href="mailto:cs@suntone.com">cs@suntone.com</a></div>
			</div>
		</div>
		<div class="twoSectionTitleBoxStyle" v-if="contType == 'f'">
				<div class="wow bounceInUp twoTitleT2Style">
					<p class="cates">
				<img class="thumb" src="../assets/img/custom-website-site-builder.jpg"/>
				<div class="t">網站建設</div>
				在當今數字時代，擁有一個專業且功能齊全的網站對於任何企業來說都是至關重要的。我們Suntone Technology Co., Limited明白，並不是每個子商戶都有技術專長或資源來建立自己的網站。因此，我們提供全面的網站建設服務。我們經驗豐富的開發人員和設計師團隊將與您緊密合作，創建一個不僅外觀出色而且用戶體驗優秀的定製網站。從初始設計概念到最終部署，我們處理網站創建過程的每一個方面，確保您的在線形象既有效又吸引人。</p>
			<br style="clear: both;"/>
			<p class="cates">
				<img class="thumb" src="../assets/img/h3-image-2.png"/>
				<div class="t">搜索引擎優化（SEO）
				</div>
				在搜索引擎上的可見性對於增加流量和提升銷售至關重要。我們Suntone Technology Co., Limited的SEO服務旨在幫助子商戶在搜索引擎結果頁面上獲得更高排名。我們采用多種策略，包括關鍵詞研究、頁面優化、內容創建和鏈接建設，以增強您網站的可見性。通過提高您的搜索引擎排名，我們幫助您吸引更多的有機流量，從而增加銷售並增強在線形象。我們的團隊始終跟蹤最新的SEO最佳實踐和算法變化，確保您的網站在不斷變化的數字環境中保持競爭力。</p>
			<br style="clear: both;"/>
			<p class="cates">
				<img class="thumb" src="../assets/img/selection-product.webp"/>
				<div class="t">產品選擇
				</div>
				選擇合適的產品進行銷售可以決定您的業務成敗。我們Suntone Technology Co., Limited提供產品選擇服務，幫助子商戶做出關於庫存的明智決策。我們的專家分析市場趨勢、客戶偏好和競爭格局，識別出需求高且盈利能力強的產品。通過利用我們的見解和專業知識，您可以為您的商店儲備更有可能銷售的商品，從而減少未售出庫存的風險並最大化您的收入潛力。無論您是剛起步還是希望擴展產品線，我們的產品選擇服務都能為您提供成功所需的指導。</p><br style="clear: both;"/>
				<p class="cates">
				<img class="thumb" src="../assets/img/From-Concept-to-Launch_-Building-a-Product-with-AI-Assistance-scaled.jpg"/>
				<div class="t">AI功能集成
				</div>
				人工智能（AI）正在改變企業與客戶互動的方式。我們Suntone Technology Co., Limited提供AI功能集成服務，幫助子商戶提升客戶服務和運營效率。我們的AI解決方案包括先進的功能，如AI聊天機器人，能夠為您的客戶提供即時、個性化的支持，回答常見問題並協助完成常見任務。通過將AI集成到您的網站中，您可以改善用戶體驗，縮短響應時間，並讓您的團隊專註於更復雜的問題。我們的AI服務設計為可擴展且適應性強，確保它們滿足您的特定業務需求，並幫助您在競爭中保持領先。</p>
				<br style="clear: both;"/>
				<div style="text-align: center;">了解更多，請聯系 <a href="mailto:cs@suntone.com">cs@suntone.com</a></div>
			</div>

		</div>
			<div class="twoSectionTitleBoxStyle" v-if="contType == 'e'">
				<div class="wow bounceInUp twoTitleT2Style">
			<p class="cates">
				<img class="thumb" src="../assets/img/custom-website-site-builder.jpg"/>
				<div class="t">Website Construction</div>
				In today's digital age, having a professional and functional website is crucial for any business. At Suntone Technology Co., Limited, we understand that not every sub merchant has the technical expertise or resources to build their own website. That's why we offer our comprehensive website construction service. Our team of experienced developers and designers will work closely with you to create a custom website that not only looks great but also provides an excellent user experience. From initial design concepts to final deployment, we handle every aspect of the website creation process, ensuring your online presence is both effective and engaging.
			</p>
			<br style="clear: both;"/>
			<p class="cates">
				<img class="thumb" src="../assets/img/h3-image-2.png"/>
				<div class="t">SEO (Search Engine Optimization)</div>
				Visibility on search engines is paramount to driving traffic and increasing sales. Our SEO services at Suntone Technology Co., Limited are designed to help sub merchants achieve higher rankings on search engine results pages. We employ a variety of strategies, including keyword research, on-page optimization, content creation, and link building, to enhance your website's visibility. By improving your search engine rankings, we help you attract more organic traffic, which can lead to increased sales and a stronger online presence. Our team stays up-to-date with the latest SEO best practices and algorithm changes to ensure your website remains competitive in the ever-evolving digital landscape.
			</p>
			<br style="clear: both;"/>
			<p class="cates">
				<img class="thumb" src="../assets/img/selection-product.webp"/>
				<div class="t">Products Selection</div>
				Selecting the right products to sell can make or break your business. At Suntone Technology Co., Limited, we offer a product selection service that helps sub merchants make informed decisions about their inventory. Our experts analyze market trends, customer preferences, and competitive landscapes to identify products with high demand and profitability. By leveraging our insights and expertise, you can stock your store with items that are more likely to sell, reducing the risk of unsold inventory and maximizing your revenue potential. Whether you're just starting out or looking to expand your product line, our product selection service provides the guidance you need to succeed.</p>
				<br style="clear: both;"/>
				<p class="cates">
				<img class="thumb" src="../assets/img/From-Concept-to-Launch_-Building-a-Product-with-AI-Assistance-scaled.jpg"/>
				<div class="t">AI Function Build-in
				</div>
				Artificial Intelligence (AI) is transforming the way businesses interact with their customers. At Suntone Technology Co., Limited, we offer AI function build-in services to help sub merchants enhance their customer service and operational efficiency. Our AI solutions include advanced features such as AI chatbots, which can provide instant, personalized support to your customers, answer frequently asked questions, and assist with common tasks. By integrating AI into your website, you can improve user experience, reduce response times, and free up your team to focus on more complex issues. Our AI services are designed to be scalable and adaptable, ensuring they meet your specific business needs and help you stay ahead of the competition.</p>
				<br style="clear: both;"/>
				<div style="text-align: center;">For more information, please send an email to <a href="mailto:cs@suntone.com">cs@suntone.com</a></div>
			</div>
		</div>
		</div>
	</div>
</template>

<script>


import { Email } from "../utils/smtp.js";
import { WOW } from "wowjs";

export default {
	name: "index",
	data: (vm) => {
		return {
			bodyW: 0,
			bodyY: 0,
			position: "",
			position2: "",
			contList: {
				title1: {
					z: "增值服务",
					f: "增值服務",
					e: 'Value-added Service'
				},
				title2: {
					z: "为新手卖家提供建站，搜索引擎优化，选品及AI工具相关的服务！",
					f: "為新手賣家提供建站，搜索引擎優化，選品及AI工具相關的服務！",
					e: "Provide services related to website building, search engine optimization,\nproduct selection and AI tools for novice sellers"
				},
			},
			contType: "z",

		};
	},
	methods: {
		move(e) {
			if (e.pageX > this.bodyW / 2) {
				this.position = "right";
			} else {
				this.position = "left";
			}
			if (e.pageY > 250) {
				this.position2 = "top";
			} else {
				this.position2 = "bottom";
			}
		},
		changeTypeTitleName() {
			if (this.contType == "f") {
				document.title = "關於我們";
			} else if (this.contType == 'e') {
				document.title = 'About Us'
			} else {
				document.title = "关于我们";
			}
		}

	},

	mounted() {
		this.bodyW = document.body.clientWidth;
		this.bodyY = document.body.clientHeight;
		var that = this;
		this.contType = window.localStorage.getItem('language');
		that.changeTypeTitleName()
		window.addEventListener('setItemEvent', function (e) {
			if (e.key == "language") {
				that.contType = e.newValue;
				that.changeTypeTitleName()
			}
		})
		var wow = new WOW({
			boxClass: "wow",
			animateClass: "animated",
			offset: 40,
			mobile: true,
			live: true,
		});
		wow.init();
		//QOFGPGRDUUMNZALE


	},
};
</script>

<style src="../assets/css/AboutUs-pc.css"  scoped>

</style>
<style src="../assets/css/AboutUs-phone.css"  scoped>

</style>
<style scoped>
.thumb {
	float:left; 
	width: 325px; 
	height: 220px;
	border: 1px solid #ddd;
	margin: 20px 20px 0 0;
	border-radius: 8px;
}
.twoTitleT2Style {
	display: block;
}
.cates {
	margin-bottom: 30px;
}
.cates div.t {
	text-indent: 0;
	font-size: 18px;
	color:#555;
	font-weight: 700;
}
@media screen and (min-width: 801px) {
	.twoTitleT2Style {
		text-indent: 0;
	}
	.twoTitleT2Style .t {
		font-size: 18px;
		font-weight: 700;
		color:#555;
	}
}
@media screen and (max-width: 800px) {
	.twoTitleT2Style {
		text-indent: 0;
	}
	.twoTitleT2Style .t {
		font-size: 18px;
		font-weight: 700;
		color:#555;
	}
}
</style>
<!-- </style> -->
